<template>
  <JobCostBreakdown :job-id="jobId">
    <span
      class="inline-flex items-center gap-1 cursor-help"
      tabindex="0"
      data-cy="job-cost-technicians"
    >
      <span>{{ name }}</span>
      <Badge
        v-if="more > 0"
        variant="chip"
        color="gray"
        data-cy="job-cost-technicians-more"
        :text="`+${more}`"
      />
    </span>
  </JobCostBreakdown>
</template>

<script setup lang="ts">
import Badge from "@/components/Badge.vue";
import JobCostBreakdown from "@/Reports/JobCostBreakdown.vue";

defineProps<{ jobId: number; name: string; more: number }>();
</script>
